import { AxiosRequestConfig } from 'axios';

import { apiClient } from '@/lib/api/client';
import { PaginatedResponse } from '@/lib/api/types';
import { PaginationSearchParamsType } from '@/lib/utils/pagination';

import {
  CheckoutResponse,
  CreateSessionCheckoutPayload,
  Order,
  OrderResellResponse,
} from '../types';

export const getUserOrders = async (
  options?: AxiosRequestConfig,
): Promise<Order[]> => {
  return apiClient<Order[]>(
    {
      method: 'GET',
      url: `/orders`,
    },
    options,
  );
};

export const getStoreOrders = async (options?: AxiosRequestConfig) => {
  return apiClient<Order[]>(
    {
      method: 'GET',
      url: `/orders/store`,
    },
    options,
  );
};

export const getOrder = async (id: string, options?: AxiosRequestConfig) => {
  return apiClient<Order>(
    {
      method: 'GET',
      url: `/orders/${id}`,
    },
    options,
  );
};

export const createCheckoutSession = async (
  data: CreateSessionCheckoutPayload,
  options?: AxiosRequestConfig,
) => {
  return apiClient<CheckoutResponse>(
    {
      method: 'POST',
      url: '/orders/checkout',
      data,
    },
    options,
  );
};

export const getAdminOrders = (params: PaginationSearchParamsType) => {
  return apiClient<PaginatedResponse<Order>>({
    url: '/admin/orders',
    method: 'GET',
    params,
  });
};

export const resellOrder = (id: string) => {
  return apiClient<OrderResellResponse>({
    url: `/orders/resell/${id}`,
    method: 'POST',
  });
};

export const resellOrderItem = (orderId: string, orderItemId: string) => {
  return apiClient<OrderResellResponse>({
    url: `/orders/resell-item/${orderId}`,
    method: 'POST',
    data: { orderItemId },
  });
};
